import React from 'react';
import PropTypes from 'prop-types';
import { isNonEmptyString, createCustomPropType } from '../../../js/app/react/validators';
import Next from './Next/NextContainer';
import Back from './Back/BackContainer';

const NavigationView = ({
  workflowId,
  backendKey,
  validator,
  validationId,
  doNotSave,
  isFirstStep,
  onPostProcess,
  onPostSave,
  validatedOnClick,
  nextTitle,
  nextIterators,
  dirtyGraphNodes,
  hasSkip,
}) => (
  <div className="adv-workflow-navigation">
    <Back isFirstStep={isFirstStep} workflowId={workflowId} validationId={validationId} />
    <Next
      onPostProcess={onPostProcess}
      onPostSave={onPostSave}
      workflowId={workflowId}
      backendKey={backendKey}
      validator={validator}
      validationId={validationId}
      doNotSave={doNotSave}
      validatedOnClick={validatedOnClick}
      nextTitle={nextTitle}
      nextIterators={nextIterators}
      dirtyGraphNodes={dirtyGraphNodes}
      hasSkip={hasSkip}
    />
  </div>
);

NavigationView.defaultProps = {
  validatedOnClick: () => {},
  nextTitle: null,
  hasSkip: false,
};

NavigationView.propTypes = {
  nextTitle: PropTypes.string,
  validator: PropTypes.func.isRequired,
  onPostProcess: PropTypes.func.isRequired,
  onPostSave: PropTypes.func.isRequired,
  doNotSave: PropTypes.bool.isRequired,
  isFirstStep: PropTypes.bool.isRequired,
  workflowId: createCustomPropType(isNonEmptyString).isRequired,
  backendKey: createCustomPropType(isNonEmptyString).isRequired,
  validationId: createCustomPropType(isNonEmptyString).isRequired,
  validatedOnClick: PropTypes.func,
  nextIterators: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)).isRequired,
  dirtyGraphNodes: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)).isRequired,
  hasSkip: PropTypes.bool,
};

export default NavigationView;
